"use strict";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
console.log("Chemin JS fonctionnel");

/* Variables */
const backBg = document.querySelector('.accueil__bg--back');
const middleBg = document.querySelector('.accueil__bg--middle');
const frontBg = document.querySelector('.accueil__bg--front');
const sections = document.querySelectorAll("section");
const logoMenu = document.querySelector('.menu__logo');
const toggleMenu = document.querySelector('.menu__toggle');
const cercleMenu = document.querySelector('.menu__cercle');
const listMenu = document.querySelector('.menu__list');
const elMenu = document.querySelectorAll(".menu__el");
const iconMenu = document.querySelector('.menu__icon');
const linksMenu = document.querySelectorAll('.menu__list a');
const indicateur = document.querySelector('.accueil__indications img');
const couronneMessage = document.querySelector(".message__couronne");
const mediaQuery = window.matchMedia("(min-width: 768px) and (min-height: 768px)");

/* Media Menu */
document.addEventListener("DOMContentLoaded", () => {
  const toggleListMenu = () => {
    listMenu?.classList.toggle("display--none", !mediaQuery.matches);
  };

  toggleListMenu();
  mediaQuery.addEventListener("change", toggleListMenu);
});

/* Hauteur Dynamique */
function setViewportHeight() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

setViewportHeight();

window.addEventListener('orientationchange', () => {
  setTimeout(setViewportHeight, 100);
});

/* Animations GSAP */

/* États actifs Nav */
sections.forEach(section => {
    ScrollTrigger.create({
        trigger: section,
        start: "top center",
        end: "bottom center",
        onEnter: () => setActive(section.id),
        onEnterBack: () => setActive(section.id),
    });
});

function setActive(id) {
    elMenu.forEach(item => {
        const link = item.querySelector("a");
        const href = link.getAttribute("href").replace("#", "");
        if (href === id) {
            item.classList.add("menu__el--jaune");
        } else {
            item.classList.remove("menu__el--jaune");
        }
    });
}

/* Rotation Pièce */
function animatePieces(selector = ".spawn-piece") {
    const pieces = document.querySelectorAll(selector);
    if (!pieces) return;

    pieces.forEach(piece => {
        gsap.from(piece, {
            opacity: 0,
            scale: 0.5,
            rotationY: 90,
            duration: 0.5,
            ease: "back.out(1.7)"
        });

        gsap.to(piece, {
            rotationY: 720,
            duration: 2,
            ease: "power3.out"
        });
    });
}

window.addEventListener("load", () => {
    requestAnimationFrame(() => {
        setTimeout(() => animatePieces(), 100);
    });
});

/* Apparition Stagger */
function animateStagger(target) {
    gsap.fromTo(
        target.children,
        {
            opacity: 0,
            scale: 0.5,
        },
        {
            duration: 0.3,
            opacity: 1,
            scale: 1,
            stagger: 0.1,
            ease: "back.out(1.5)",
        }
    );
}

gsap.utils.toArray(".spawn-stagger").forEach((element) => {
    observerStagger.observe(element);
});

/* Fade */
document.querySelectorAll(".fade").forEach((element) => {
  gsap.fromTo(
    element,
    { opacity: 0 },
    {
      opacity: 1,
      ease: "power2.out",
      duration: 1,
      scrollTrigger: {
        trigger: element,
        start: "top 75%",
        end: "bottom 25%",
        toggleActions: "play reverse play reverse",
      }
    }
  );
});

/* Fade Right */
document.querySelectorAll(".fade-right").forEach((element) => {
    gsap.fromTo(
        element,
        { opacity: 0, x: -100 },
        {
            opacity: 1,
            x: 0,
            ease: "power2.out",
            duration: 1,
            scrollTrigger: {
                trigger: element,
                start: "top 75%",
                end: "bottom 25%",
                toggleActions: "play none none reverse",
            }
        }
    );
});

/* Rotation */
let rotated = false;
function rotate(el) {
    gsap.to(el, {
        rotation: rotated ? 0 : 90,
        duration: 0.5,
        ease: "power1.inOut"
    });
    rotated = !rotated;
}

/* Cercle Paramètres */
let expanded = false;
let isAnimating = false;

function getDiagonalSize() {
  return Math.ceil(Math.sqrt(window.innerWidth ** 2 + window.innerHeight ** 2)) * 2.2;
}

function updateTailleCercle() {
    const size = getDiagonalSize();
    isAnimating = true;

    if (expanded) {
        gsap.to(cercleMenu, {
            width: size + 'px',
            height: size + 'px',
            duration: 0.5,
            ease: 'power1.inOut',
            onComplete: () => {
                listMenu.classList.remove('display--none');
                animateStagger(listMenu);
                isAnimating = false;
            }
        });
    } else {
        listMenu.classList.add('display--none');
        gsap.to(cercleMenu, {
            width: '0px',
            height: '0px',
            duration: 0.5,
            ease: 'power1.inOut',
            onComplete: () => {
                isAnimating = false;
            }
        });
    }
}

if (toggleMenu) {
    toggleMenu.addEventListener('click', () => {
        if (isAnimating) return;

        rotate(toggleMenu);
        expanded = !expanded;

        if (expanded) {
            iconMenu.src = import.meta.env.BASE_URL + "/assets/images/croix.svg";
            iconMenu.alt = "icone de fermeture";
        } else {
            iconMenu.src = import.meta.env.BASE_URL + "/assets/images/burger.svg";
            iconMenu.alt = "icone du menu burger";
        }

        updateTailleCercle();
    });

    window.addEventListener('resize', () => {
        if (expanded && !isAnimating) updateTailleCercle();
    });
}

if (toggleMenu) {
    const handleMenuClose = () => {
        if (expanded && !isAnimating && !mediaQuery.matches) {
            rotate(toggleMenu);
            expanded = false;

            iconMenu.src = import.meta.env.BASE_URL + "/assets/images/burger.svg";
            iconMenu.alt = "icone du menu burger";

            updateTailleCercle();
        }
    };

    linksMenu.forEach(link => {
        link.addEventListener('click', handleMenuClose);
    });

    logoMenu.addEventListener('click', handleMenuClose);
}

/* Parallaxe et Anim Accueil */

/* Souris */
const isMobile = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

if (!isMobile && backBg && middleBg && frontBg) {
    document.addEventListener('mousemove', onMouseMove);
}

function onMouseMove(e) {
    const relX = e.clientX / window.innerWidth - 0.5;
    const relY = e.clientY / window.innerHeight - 0.5;

    const backX = -relX * 20;
    const backY = -relY * 20;

    const middleX = -relX * 30;
    const middleY = -relY * 30;

    const frontX = -relX * 40;
    const frontY = -relY * 40;

    gsap.to(backBg, {
        x: backX,
        y: backY,
        duration: 0.4,
        ease: "power2.out"
    });

    gsap.to(middleBg, {
        x: middleX,
        y: middleY,
        duration: 0.4,
        ease: "power2.out"
    });

    gsap.to(frontBg, {
        x: frontX,
        y: frontY,
        duration: 0.4,
        ease: "power2.out"
    });
}

/* Perpétuel Indicateur */
if (indicateur){
    gsap.to(indicateur, {
        y: -10,
        duration: 1,
        repeat: -1,
        yoyo: true,
        ease: "power1.inOut"
    });
}

/* Trigger Couronne */
if (couronneMessage){
    gsap.set(".message__couronne", {
        opacity: 0,
        y: -50,
        scale: 0.7,
    });

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: ".message__couronne",
            start: "top 75%",
            end: "bottom 25%",
            toggleActions: "play none none reverse",
        }
    });

    tl.to(".message__couronne", {
        duration: 0.8,
        opacity: 1,
        scale: 1,
        ease: "power3.out"
    })
    .to(".message__couronne", {
        duration: 1.5,
        y: 0,
        ease: "power3.out"
    });
}